import React, { useState, useEffect } from "react";
import { Box, useTheme, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../theme";
import Header from "./Header";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import VideoModal from "./VideoModal";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import styled from "styled-components";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { EasyToastify } from "../Extentions/EasyToastify";
import { useNavigate, useLocation } from "react-router-dom";

const StyledImg = styled.img`
  width: 144px;
  height: 81px;
  object-fit: contain;

  @media only screen and (max-width: 480px) {
    width: 40px;
    height: 24px;
  }
`;

const StyledA = styled.a`
  color: #94e2cd;

  @media only screen and (max-width: 480px) {
    font-size: 8px;
  }
`;

const VideoList = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [newsData, setNewsData] = useState(null);
  const [isDataSet, setIsDataSet] = useState(false);
  const [modal, setModal] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleModal = () => {
    setModal(!modal);
    if (modal) {
      getVideos();
    }
  };

  const getVideos = async () => {
    const controller = new AbortController();
    try {
      const response = await axiosPrivate.get(
        "/NewsMaker/GetVideoForNewsMakerList",
        {
          signal: controller.signal,
        }
      );
      setNewsData(response.data);
    } catch (err) {
      navigate("/", { state: { from: location }, replace: true });
    }
    return () => {
      controller.abort();
    };
  };

  const deleteVideo = async (id) => {
    const controller = new AbortController();
    try {
      await axiosPrivate
        .delete(`/newsmaker/DeleteVideo?id=${id}`, {
          signal: controller.signal,
        })
        .then((res) => {
          if (res.status === 200) {
            EasyToastify.ToastSuccess("Video Deleted");
          }
        });
    } catch (err) {
      if (err.request.status === 400) {
        EasyToastify.ToastError("News does not exists");
      } else if (err.request.status === 500) {
        EasyToastify.ToastError("Server Down Or in Maintenance");
      } else {
        EasyToastify.ToastError("Unhendled exeption");
      }
    }
  };

  useEffect(() => {
    if (!isDataSet) {
      getVideos();
      setIsDataSet(true);
    }
  }, [newsData]);

  const handleDelete = async (e, id) => {
    if (window.confirm("do you want to delete?")) {
      await deleteVideo(id);
    }
    getVideos();
  };

  const columns = [
    {
      field: "videoUrl",
      headerName: "Video Image Preview",
      flex: 0.5,
      renderCell: (params) => {
        return (
          <a
            href={"https://youtu.be/" + params.value}
            target="_blank"
            rel="noopener noreferrer"
          >
            <StyledImg
              src={
                "https://img.youtube.com/vi/" + params.value + "/sddefault.jpg"
              }
              alt=""
            />
          </a>
        );
      },
    },
    {
      field: "videoUrlTitle",
      headerName: "Video Url Title",
      flex: 1,
      cellClassName: "name-column--cell",
      renderCell: (params) => {
        return (
          <StyledA
            href={"https://youtu.be/" + params.row.videoUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {"https://youtu.be/" + params.row.videoUrl}
          </StyledA>
        );
      },
    },
    { field: "gameId", headerName: "Game ID", flex: 0.3 },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            onClick={(e) => handleDelete(e, params.row.id)}
            variant="contained"
          >
            <DeleteOutlinedIcon />
          </Button>
        );
      },
    },
  ];

  if (newsData === null) {
    setNewsData([]);
  }
  {
    return (
      <Box m="20px">
        <Header title="Video LIST" subtitle="List of Videos" />
        <Button
          variant="outlined"
          size="large"
          sx={{ color: "green", backgroundColor: "#2f475d" }}
          onClick={toggleModal}
        >
          Add Video&nbsp;
          <AddCircleOutlineOutlinedIcon fontSize="large" />
        </Button>
        <VideoModal
          apiUrl="CreateVideo"
          modal={modal}
          toggleModal={toggleModal}
          getvideos={getVideos}
        />
        <Box
          m="40px 0 0 0"
          height="69vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${colors.grey[100]} !important`,
            },
          }}
        >
          <DataGrid
            rows={newsData}
            getRowHeight={() => "auto"}
            columns={columns}
          />
        </Box>
      </Box>
    );
  }
};

export default VideoList;
